import { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Facility from "./Facility";
import "./css/school_details.css";
import BookDemo from "./BookDemo";
import { apiUrl } from "../../../http-common";

const SchoolDetailsPage = () => {
  const [schoolDetails, setSchoolDetails] = useState({});
 
  function calculatedDistanceDelta() {
    return "2.5 Km";
  }
  const url = window.location.pathname;
  const parts = url.split("/");
  const tenant_id = parts[2]; 

  useEffect(function loadAllSchoolData() {
    const fetchSchool = async () => {
      const response = await fetch(
        `${apiUrl}institutions/schools-list/${tenant_id}
`,
        { method: "GET" }
      );

      const reduced_response = response.json();
      reduced_response.then((data) => {
        setSchoolDetails(data);
      });
    };
    fetchSchool();
  }, []);


  const facilityImages = {
    canteen: "canteen.png",
    "computer lab": "computer_lab.png",
    library: "library.png",
    "medical room": "medical_room.png",
    sports: "sports.png",
    "play ground": "play_ground.png",
    "office buildings": "office_buildings.png",
    escalators: "escalators.png",
    "Play Ground": "playground.png",
    laboratory: "best_facilities_laboratory_grey.png"
  };
 
  return (
    <div className="school_details_page">
      <div
        className="header"
        style={{ 
          backgroundImage: `url("${schoolDetails?.banner}")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#000000",
        }}
      >
        <Header />
        <h1 className="school_name">{schoolDetails?.institution_name}</h1>
        <p className="school_motto">{schoolDetails?.motto}</p>
        <div className="school_contacts_and_address">
          {schoolDetails?.address?.length > 0 && (
            <p>
              <span className="icon_container">
                <img
                  src="/new_landing_page_images/location_green.svg"
                  alt="school address"
                />
              </span>
              <span className="text">{schoolDetails?.address}</span>
            </p>
          )}
          {schoolDetails?.phoneNumber?.length > 0 && (
            <p>
              <span className="icon_container">
                <img
                  src="/new_landing_page_images/phone_green.svg"
                  alt="school phone"
                />
              </span>
              <span className="text">{schoolDetails?.phoneNumber}</span>
            </p>
          )}
          {schoolDetails?.website?.length > 0 && (
            <p>
              <span className="icon_container">
                <img
                  src="/new_landing_page_images/globe_green.svg"
                  alt="school website"
                />
              </span>
              <span className="text">{schoolDetails?.website}</span>
            </p>
          )}
        </div>
      </div>
      <div className="bottom">
        <div className="logo_exam_board_et_all">
          <div className="left">
            <div className="logo_container">
              <img
                src={schoolDetails?.logo}
                alt={`${schoolDetails?.institution_name} logo`}
              />
            </div>
            {schoolDetails?.exam_boards?.map((exam_board) => (
              <span className="info">{exam_board}</span>
            ))}
            <span className="info">{schoolDetails?.language}</span>
            <span className="info">{schoolDetails?.learning_range}</span>
            <span className="info">{schoolDetails?.gender}</span>
          </div>
          <div className="right">
            <span className="distance">{calculatedDistanceDelta()}</span>
            <span className="rating">{schoolDetails?.rating}</span>
          </div>
        </div>
        <h2>Facilities</h2>
        <div className="facilities_list">
          {schoolDetails?.facilities?.map((facility, index) => (
            <Facility
              key={index}
              name={facility}
              icon_url={`/new_landing_page_images/${
                facilityImages[facility.toLowerCase()] || "form_avatar.svg"
              }`}
            />
          ))}
        </div>
        <div className="images_gallery">
          {schoolDetails?.gallery?.map((image_url, index) => (
            <div key={index} className="image_container">
              <img src={image_url} alt={image_url} />
            </div>
          ))}
        </div>
      </div>
      <Footer />
      <BookDemo />
    </div>
  );
};

export default SchoolDetailsPage;
